import axios from "axios";
import GetUserData from "../utilities/getUserDetails";

//author-saksham
//function-to generate token
const fetchToken = async () => {
    const encodedParams = new URLSearchParams();
    encodedParams.set("UserName", localStorage.getItem('loginEmail'));
    encodedParams.set("Password", localStorage.getItem('loginPassKey'));
    encodedParams.set("Grant_type", "password");


    // const url = "https://staging2.lalpathlabs.com/npsapi/token";
    const url = "https://webapi.lalpathlabs.com/npsapi_pre/token";
    const options = {
      method: "POST",
      headers: {
        Accept: "*/*",
        "User-Agent": "Thunder Client (https://www.thunderclient.com)",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: encodedParams,
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      const token = data.access_token;
      localStorage.setItem("authToken", token);
      return token;
    } catch (error) {
        console.error('Error fetching token:', error.response?.data || error.message);
      return error;
    }
};

export default fetchToken;
//end
